<template>
    <div class="acomodar">
        <accesoCapacitacion/>
    </div>
</template>

<script>
import accesoCapacitacion from '../../components/ModSST/Capacitaciones/accesoCapacitacion.vue';
export default {
    name: 'SolimanoLogAccesosCapacitacion',
    components:{
        accesoCapacitacion
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>

.acomodar {
    box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y:hidden;
}

</style>